// src/ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const ThemeContext = createContext();
export const useTheme = () => useContext(ThemeContext);

export const ThemeProviderComponent = ({ children }) => {
  const getInitialMode = () => {
    const stored = localStorage.getItem('darkMode');
    if (stored !== null) {
      return JSON.parse(stored); // Use saved preference
    }
    // Default to light mode when no preference stored
    return false;
  };

  const [darkMode, setDarkMode] = useState(getInitialMode);

  const toggleDarkMode = () => {
    setDarkMode(prevMode => {
      const next = !prevMode;
      localStorage.setItem('darkMode', JSON.stringify(next));
      return next;
    });
  };

  // Defensive: update localStorage in case toggle didn't trigger
  useEffect(() => {
    localStorage.setItem('darkMode', JSON.stringify(darkMode));
  }, [darkMode]);

  const theme = createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
    },
  });

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <ThemeProvider theme={theme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};
